import React from 'react'

import { SUI } from 'shared/ui'

import Header from './Header'
import SearchableList from './SearchableList'
import Actions from './Actions'

const EditPane = props => {
  return (
    <React.Fragment>
      <SUI>
        <Header key="header" text="Add some tags" />
      </SUI>
      <SearchableList
        key="list"
        items={props.labels}
        onSelect={props.doToggleLabel}
        hidden={props.hidden}
        {...props}
      />
      <SUI>
        <Actions key="actions" {...props} />
      </SUI>
    </React.Fragment>
  )
}

export default EditPane
